export function formatTime(time: number): string {
	if (!time) {
		return '0:00';
	}
	const minutes = Math.floor(time / 60);
	const seconds = Math.floor(time - minutes * 60);
	const stringSeconds = seconds < 10 ? `0${seconds}` : seconds;
	return `${minutes}:${stringSeconds}`;
}

export const twentyFourHourTimeFormat: Intl.DateTimeFormatOptions = {
	hour: 'numeric',
	minute: '2-digit',
};
